module.exports = __webpack_public_path__ + "static/img/logo-xw.d55da76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-xw.png
// module id = h+oh
// module chunks = 1